import { Box } from '@mui/material'
import VehicleDisplayName from 'components/Common/VehicleDisplayName/VehicleDisplayName'
import QuotesTitle from 'Pages/Client/BookingStatusPage/ReallocateModal/QuotesTitle'

type QuoteListingProps = {
  quotes: any
  isImmediateJourney: boolean
  returnVehicles: boolean
  handleBookNow: any
  selectMultiple: any
  selectedVehicles: any
  setSelectedVehicles: any
  canSelectMoreCars: boolean
  vehicleDetails: any
  client?: any
}

const QuoteListing = ({
  quotes,
  isImmediateJourney,
  returnVehicles,
  selectedVehicles,
  setSelectedVehicles,
  handleBookNow,
  vehicleDetails,
  selectMultiple,
  canSelectMoreCars,
  client,
}: QuoteListingProps) => {
  return (
    <Box
      component="div"
      sx={{
        width: '100%',
        marginBottom: '20px',
      }}
    >
      <QuotesTitle
        title={VehicleDisplayName({
          vehicleDetails: vehicleDetails,
        })}
        example={vehicleDetails?.example}
        cardist={vehicleDetails?.description}
        returnVehicles={returnVehicles}
        isImmediateJourney={isImmediateJourney}
        image={vehicleDetails?.icon}
        seats={vehicleDetails?.seats}
        luggage={vehicleDetails?.luggage}
        quotes={quotes}
        handleBookCar={handleBookNow}
        selectedVehicles={selectedVehicles}
        setSelectedVehicles={setSelectedVehicles}
        selectMultiple={selectMultiple}
        canSelectMoreCars={canSelectMoreCars}
        client={client}
      />
    </Box>
  )
}

export default QuoteListing
